<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px"> {{ $t("system_code_create") }}</h6>
                   <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>

                </div>
                <div class="card-body">
              

                    <form
                        class="forms-sample"
                        @submit.prevent="submitData"
                        method="POST"
                    >
                    
 
 
 
                    <div class="row mb-2">

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('type')  }}</label>

                            <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('type')" v-model="forms.type" maxlength="255" required/>

                            <div v-if="errors.type">
                                <div v-for="error in errors.type" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('code')  }}</label>

                            <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('code')" v-model="forms.code"  maxlength="255" required/>

                            <div v-if="errors.code">
                                <div v-for="error in errors.code" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('name')  }}</label>

                            <input type="text" maxlength="255" class="form-control" :id="this.$dynamicId()" :placeholder="$t('name')" v-model="forms.name" />

                            <div v-if="errors.name">
                                <div v-for="error in errors.name" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-3">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('status')  }}</label>

                            <v-select :options="['ACTIVE','DEACTIVATE']" :id="this.$dynamicId()" v-model="forms.status" > </v-select>
 
                            <div v-if="errors.status">
                                <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>



    

                    </div>

 

                    







                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("save_change_txt") }}
                      </button>

                       
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 

export default {
    name: "CeisaSystemCodeCreate",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
        dateFilter: {
            startDate,
            endDate,
        },
        asnType: [],
        fetchAsnType: [],
        trackingOrderStatus: [],

        expectedShipmentTime1dateFilter: {
            startDate,
            endDate,
        },

        showModalNow: false,

        opens: "center",
        locale: {
            format: "yyyy-mm-dd H:MM:ss",
        },

        localeDetail: {
            format: "yyyy-mm-dd",
        },

        highlighted: {

            dates: [ // Highlight an array of dates
            new Date(),
            ],

        },

        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
        },
        fetchStockCondition: [],
        detailAsn: [],
        orderType: '',
        fetchOrderType: [],
        shelfLifeUnit: {},
        shelfLifeType: {},
        permision_role: [],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        userRole: "",
        companyCode: "",
        fetchStatus: ['ACTIVE', 'DEACTIVE'],
        fetchmultiWhFlag: ['Y', 'N'],
        fetchCustomer: [],
        fetchFulfillment: [],
        customer: "",
        fulfillment: "",
        fetchShelfLifeType: [],
        fetchShelfLifeUnit: [],
        fetchSku: [],
        activeFlag: false,
        shelfLifeFlag: false,
        kitFlag: false,
        freePickGift: false,
        isLoadingStatus: false,
        forms: {system_code_id:"", type:"", code:"", name:"", status:"", created_by:"", updated_by:"" , created_at:"", updated_at:""},
        };
    },
    watch: {},
    methods: {
 
        submitData() {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t('submitFormTxt'),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                        
                    this.isLoading = true;
 

                    const baseURI = this.$settings.endPointCeisa + "v1/system-code/store";
                    this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                        
                        this.isLoading = false;
                        this.resetForm();

                        if (response.data.status === 200) {
                            var params = this.$onRandom(response.data.datas.system_code_id);
                            window.location.href = "/exim/ceisa/system-code/detail/" + params + "?status=200&msg=Successfully";
                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }

                    }).catch((error) => {

                        this.isLoading = false;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });

                } else {

                    this.isLoading = false;
                }
            });
        },
  
  
        resetForm() {
            this.errors         = [];
            this.forms          = {system_code_id:"", type:"", code:"", name:"", status:"", created_by:"", updated_by:"" , created_at:"", updated_at:""};
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaSystemCodeController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        backForm() {
            window.location.href = "/exim/ceisa/system-code";
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();


    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>